module.exports = __webpack_public_path__ + "static/media/electronica.4c3e312b.jpg";